import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { AutomotiveAftermarketReportService } from './automotive-aftermarket-report.service';
import {
  AutomotiveAftermarketReportInitialState,
  AutomotiveAftermarketReportLoad,
} from './automotive-aftermarket-report.actions';
import { Error, CustomHttpErrorResponse } from '../../../../../common';
import { AutomotiveAftermarketProfileReport } from '../models/automotive-aftermarket-report.model';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface AutomotiveAftermarketReportStateModel {
  report: AutomotiveAftermarketProfileReport;
  loaded: boolean;
}

const initialState: AutomotiveAftermarketReportStateModel = {
  report: new AutomotiveAftermarketProfileReport(),
  loaded: false,
};

@State<AutomotiveAftermarketReportStateModel>({
  name: 'automotiveAftermarketReport',
  defaults: initialState,
})
@Injectable()
export class AutomotiveAftermarketReportState {
  constructor(
    private automotiveAftermarketReportService: AutomotiveAftermarketReportService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getReport(state: AutomotiveAftermarketReportStateModel): AutomotiveAftermarketProfileReport {
    return state.report;
  }

  @Selector()
  static getState(state: AutomotiveAftermarketReportStateModel): AutomotiveAftermarketReportStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: AutomotiveAftermarketReportStateModel): boolean {
    return state.loaded;
  }

  @Action(AutomotiveAftermarketReportLoad)
  getReport(
    ctx: StateContext<AutomotiveAftermarketReportStateModel>,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.automotiveAftermarketReportService.getReport().pipe(
      map((report: AutomotiveAftermarketProfileReport) => {
        ctx.patchState({
          report: new AutomotiveAftermarketProfileReport(report),
          loaded: true,
        });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AutomotiveAftermarketReportInitialState)
  setInitialState(ctx: StateContext<AutomotiveAftermarketReportStateModel>): void {
    ctx.setState(initialState);
  }
}
